<style lang="scss" scoped>
.modal-body {
  padding: 15px;
}
.modal-content {
  line-height: 22px;
}
.imageDiv {
  margin-right: 10px;
  height: 50px;
}
.imageDiv i {
  font-size: 30px;
  margin-top: 5px;
}
.imageDiv img {
  max-height: 50px;
}
.typelabel {
  font-size: 14px;
  font-weight: 700;
  color: #aaa;
}
.zoomer {
  width: 100%;
  height: 500px;
  border: solid 1px #f9f9f9;
}
.zoomer img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
span.from {
  display: inline-block;
  margin-top: 0px;
}
.galleryCloseButton {
  position: absolute;
  right: 5px;
  top: 5px;
  z-index: 99999;
  color: orange;
  background: none !important;
  border: none;
  padding: 10px;
}
#noticeImages img {
  width: 100%;
}
#galleryButtons {
  height: 40px;
  position: absolute;
  left: 0px;
  bottom: 0px;
  color: white;
  z-index: 9999;
  button {
    padding: 5px;
    margin: 5px;
    background: none;
    color: orange;
    border: none;
    font-size: 18px;
    i {
      vertical-align: bottom;
    }
  }
}
#galleryDiv {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
}
.float {
  position: fixed;
  top: 10px;
  right: 10px;
  background: none !important;
}
</style>
<template>
  <div class="modal-body">
    <div class="modal-header cleafix" style="position: relative">
      <div class="imageDiv pull-left">
        <img
          v-if="notice.user_type === 6 || notice.user_type === 7"
          class="profilePic"
          :src="notice.imageUrl"
        />
        <i v-if="notice.user_type === 8" class="fas fa-graduation-cap"></i>
        <i v-if="notice.user_type === 2" class="fas fa-school"></i>
        <i v-if="notice.user_type === 9" class="fas fa-book-reader"></i>
        <img
          class="adminLogo"
          v-if="notice.user_type === 5"
          src="https://s3-eu-west-1.amazonaws.com/home-run/other/logo_small.png"
        />
        <img
          class="adminLogo"
          v-if="notice.user_type == 1 || notice.user_type == 3"
          :src="notice.imageUrl"
        />
        <img
          class="adminLogo img-circle"
          v-if="notice.user_type > 20"
          :src="notice.imageUrl"
        />
      </div>
      <div class="pull-right" style="text-align: right; position: relative">
        <button
          type="button"
          class="close clickable"
          :class="{ float: notice.images && notice.images.length > 0 }"
          @click="close()"
        >
          <i class="fas fa-window-close"></i>
        </button>
        <br />
        <span
          class="timeAgo colorGrey"
          style="top: 35px; position: absolute; width: 100px; right: 5px"
        >
          <timeago :datetime="notice.created_timestamp * 1000"></timeago>
        </span>
      </div>
      <div class="middleDiv">
        <span
          class="name colorNavy from"
          v-if="notice.user_type !== 8 && notice.user_type !== 9"
          >{{ notice.from_label }}</span
        >
        <span
          class="name"
          v-if="notice.user_type === 8 || notice.user_type === 9"
          >{{ notice.salutation + " " + notice.last_name || "" }}</span
        >
        <br />
        <span class="typelabel" v-if="notice.user_type === 2"
          >School Office</span
        >
        <span class="typelabel" v-if="notice.user_type === 6">Parent</span>
        <span class="typelabel" v-if="notice.user_type === 7"
          >Parent & PTA</span
        >
        <span class="typelabel" v-if="notice.user_type === 8"
          >Head Teacher</span
        >
        <span class="typelabel" v-if="notice.user_type === 9">Teacher</span>
        <span class="typelabel" v-if="notice.user_type === 5">Admin</span>
        <span class="typelabel" v-if="notice.user_type === 3">Council</span>
        <span class="typelabel" v-if="notice.user_type === 1">School</span>
      </div>
    </div>
    <div style="clear: both"></div>
    <div class="modal-content clearfix">
      <div v-if="notice.type === 'article'" id="noticeArticle">
        <div class="mainTitle" v-if="notice.type !== 'user_post'">
          {{ notice.title }}
        </div>
        <div v-if="notice.articleImageUrl" class="articleImage">
          <img :src="notice.articleImageUrl" alt />
        </div>
      </div>
      <div v-if="notice.extras.date" id="eventInfo">
        <div class="blockText noticeText eventMiddle">
          <p class="text-left">
            <b style="font-size: 20px; padding-bottom: 5px; display: block">{{
              notice.title
            }}</b>
            <i class="far fa-calendar-alt" style="font-size: 15px"></i>&nbsp;
            <b>{{ notice.extras.date }}</b>
          </p>
        </div>
        <br />
      </div>
      <div v-if="notice.message" style="font-size: 15px" class="noticeTextp">
        <v-runtime-template :template="notice.message"></v-runtime-template>
      </div>
      <div
        v-if="
          notice.type !== 'POLL' &&
          notice.images.length > 0 &&
          notice.images[0].type !== 'mp4' &&
          notice.images[0].type !== 'gif'
        "
        id="noticeImages"
        class="noSideMargin"
      >
        <div
          class="relativeDiv"
          v-for="(image, index) in notice.images"
          :key="index"
        >
          <img
            @click="viewGallery(index)"
            :src="image.path"
            style="margin-bottom: 4px"
            alt
          />
        </div>
      </div>
      <div v-if="showGallery" id="galleryDiv">
        <button @click="hideGallery" type="button" class="galleryCloseButton">
          <i class="fas fa-window-close"></i>
        </button>
        <v-zoomer-gallery
          ref="gallery"
          style="width: 100vw; height: 100vh; z-index: 9999"
          :list="images"
          v-model="selIndex"
          :max-scale="2"
        ></v-zoomer-gallery>
        <div id="galleryButtons">
          <button :disabled="selIndex === 0" @click="selIndex -= 1">
            <i class="fas fa-angle-left"></i>
          </button>
          <span>{{ selIndex + 1 }} / {{ notice.images.length }}</span>
          <button
            :disabled="selIndex === notice.images.length - 1"
            @click="selIndex += 1"
          >
            <i class="fas fa-angle-right"></i>
          </button>
          <button @click="$refs.gallery.reset()">reset</button>
          <button @click="$refs.gallery.zoomIn()">+</button>
          <button @click="$refs.gallery.zoomOut()">-</button>
        </div>
      </div>
      <!-- <div v-if="notice.message && notice.type != 'noticeimages'">
        <v-runtime-template :template="notice.message"></v-runtime-template>
      </div>-->
      <div v-if="notice.allow_comments">
        <SectionTitle title="Comments" />
        <NewCommentBox :id="notice.id" @newCommentAdded="newCommentAdded" />
        <table class="table" border="0">
          <tbody>
            <SingleComment
              :key="comment.id"
              :user_id="user_id"
              :comment="comment"
              @removeMyComment="removeMyComment"
              v-for="comment in commentsList"
            />
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <!-- <button
          class="pull-left btn-link btn colorGrey font12"
          @click="report()"
        >
          Report
        </button> -->
        <el-button
          class="pull-right closeBig"
          type="primary"
          size="small"
          plain
          @click="close()"
          >Close</el-button
        >
        <div class="clearfix" style="clear: both"></div>
      </div>
    </div>
  </div>
</template>
<style scoped>
h1 {
  font-size: 22px;
  z-index: 999;
}
i {
  font-size: 23px;
}
button.closeBig {
  border: 1px solid #26a2ff;
  background-color: transparent;
  color: #26a2ff;
  border-radius: 20px;
}
button.closeBig {
  border: 1px solid #26a2ff;
  background-color: transparent;
  color: #26a2ff;
}
button.close {
  color: orange;
  border: 0px;
}
button.close i {
  font-size: 28px;
}
span.timeAgo {
  font-size: 11px;
}
.table {
  width: 100%;
}
</style>
<style>
.timeAgoDiv {
  color: #aaa;
  font-size: 12px;
}
.modal-footer {
  margin-top: 10px;
  border-top: 1px solid #f1f1f1;
  padding-top: 15px;
  padding-bottom: 5px;
}
.noticeTextp {
  margin-top: 15px;
}
.noticeTextp p {
  margin: 0px;
}
</style>
<script>
import VRuntimeTemplate from "v-runtime-template";
import SingleComment from "@/components/noticeTypes/other/SingleComment";
import NewCommentBox from "@/components/noticeTypes/other/NewCommentBox";
import SectionTitle from "@/components/SectionTitle";
import ApiService from "@/services/ApiService";

export default {
  name: "singlenotice",
  components: {
    VRuntimeTemplate,
    NewCommentBox,
    SingleComment,
    SectionTitle,
  },
  props: {
    // message: Object,
    noticeId: Number,
    notice: Object,
    comments: Array,
  },
  data() {
    return {
      message: {
        images: [],
      },
      newComment: "",
      currentUser: {
        profile_photo_url: "none",
      },
      allowComments: true,
      commentsList: [],
      // comments: [],
      returnData: {
        views: 1,
        comments: 0,
      },
      selIndex: 0,
      showGallery: false,
    };
  },
  methods: {
    newCommentAdded(data) {
      this.commentsList.unshift(data);
    },
    viewGallery(imageIndex) {
      this.showGallery = true;
      this.selIndex = imageIndex;
    },
    hideGallery() {
      this.showGallery = false;
    },
    testMethod() {
      alert("warking");
    },
    report() {
      // var notice_id, user_id;
      // ModalService.showModal({
      //   templateUrl: "includes/reportUserModal.view.html",
      //   controller: "ReportUserController",
      //   inputs: {
      //     notice_id: $scope.notice.id != undefined ? $scope.notice.id : 0,
      //     user_id:
      //       $scope.notice.user_id != undefined ? $scope.notice.user_id : 0
      //   }
      // });
    },
    removeMyComment(id) {
      let index;
      for (let i = 0; i < this.comments.length; i++) {
        if (this.comments[i].id == id) {
          index = i;
        }
      }
      ApiService.generalApi.removeComment(id).then(() => {
        this.comments.splice(index, 1);
      });
    },
    close() {
      // this.$parent.$emit("newAvatar", this.returnData);
      this.$emit("close");
    },
  },
  computed: {
    images: function () {
      return this.notice.images.map((obj) => obj.path);
    },
    user_id: function () {
      return parseInt(this.$store.state.user.id);
    },
  },
  mounted() {
    if (this.notice && this.notice.extras && this.notice.extras.date) {
      // const d = new Date(this.notice.extras.date);
    }
    this.commentsList = this.comments;
    // this.$store.dispatch("loading", true);
    // this.getNotice(this.noticeId);
  },
};
</script>
